import React from 'react'

export default function LoginPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="w-full max-w-md rounded-lg border bg-card p-6 text-card-foreground shadow">
        <div className="mb-4">
          <h1 className="text-xl font-semibold">Email Sync Admin – Login</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Jelentkezz be az admin email+password párossal (ENV: ADMIN_UI_EMAIL/ADMIN_UI_PASSWORD).
          </p>
        </div>
        <form method="post" action="/ui/login" className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              required
              placeholder="admin@example.com"
              className="w-full rounded-md border bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="text-sm">Jelszó</label>
            <input
              id="password"
              name="password"
              type="password"
              required
              placeholder="••••••••"
              className="w-full rounded-md border bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
          <button
            type="submit"
            className="inline-flex w-full items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
            title="Sign in to the admin UI"
          >
            Bejelentkezés
          </button>
        </form>
        <p className="mt-3 text-xs text-muted-foreground">
          Elfelejtetted a jelszót? Frissítsd az ENV változókat és indítsd újra a szolgáltatást.
        </p>
      </div>
    </div>
  )
}

